import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment';
import { messagefromComponent } from '../../class/appinterface';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { NicaAnagraficaComponent, ToolbarButton } from '../nica-anagrafica/nica-anagrafica.component';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';

@Component({
  selector: 'app-gestionecer',
  templateUrl: './gestionecer.component.html',
  styleUrls: ['./gestionecer.component.css']
})
export class GestionecerComponent implements OnInit {
  @ViewChild('uElenco', { static: false }) uElenco: NicaAnagraficaComponent;
  @Input() itemData: any
  currentIndex=1;
  myFilterStr;
  costantValues: any[]=[];
  idTabRif: number;
  nomeTabRif: any;
  dati: any;
  infoDatasource={
    api:'AlboCarrozzeriaMobileCer'
  }
  PulsantiSuNavBar : ToolbarButton[] =[
    {
      location : 'before' ,
      options : {
        icon : 'paste',
        title : 'Icolla Formato Albo',
        text:'',
        index:1,
        id:"uno",
      }     
    },
    {
      location : 'before' ,
      options : {
        icon : 'trash',
        title : 'Elimina Tutti',
        text:'',
        index:2,
        id:"due"   
      }     
    }

  ]

  constructor(private appService: Apiservice,private spinner: NgxSpinnerService,private httpClient:HttpClient,private userComponentService: ComponentService, private _overlaySidePanelService: OverlaySideFormService) { }

  ngOnInit() {
    if (this.itemData) {
     
      this.idTabRif   = this.itemData[0]['idTabRif']
      this.nomeTabRif = this.itemData[0]['nomeTabRif']
      this.dati       = this.itemData[0]['dati']
      this.myFilterStr = '?IdAlboCarrozzeriaMobile=' + this.idTabRif
    } 

  }

  onAllEvent(e){
    //

/*
e.name="setCellValue";  
  e.rowData=rowData;
  e.value=value;
  e.masterThis=masterThis;
*/
    if(e.name=="setCellValue" ){
      console.log("In CER setCellValue ",e); 
      e.rowData='ddddd'     
      //e.component.addRow();
      
  }   
   
    

    if(e.name=="onSaving" ){
     
      if (e.name == ('onSaving')) {
        //alert(this.itemData[0]['nomeTabella']);
        e.changes[0]['data']['idAlboCarrozzeriaMobile'] = this.idTabRif;
        e.changes[0]['data']['allCER'] =[];      
      }



      //let cer=e.changes[0]['data']['cer'];
      /*
     this.appService.GetApi('Cer/'+cer).then(response=>{
      console.log("Lettoooooooooooo ",response);
      alert(response['descrizione']);
      e.changes[0]['data']['Descrizione'] = response['descrizione'];
     })
        e.changes[0]['data']['allCER']=[];
     */
    }
//
if(e.name=="onRowInserted" ){
 
    console.log("ecco quello che ho inserito ",e)
}
    if(e.name=="onSaved" ){
 
      //e.component.addRow();
      
  }
    //console.log("In Cer Trasportabili ",e);
  }




  optionalBottoneToolbar(event){
    //alert(this.currentIndex);
    //alert(this.companies[this.currentIndex-1].Categoria);
    
    if(event==1)
      this.paste();
    else
    {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'text');      
      const body={};
      const EndPoint=environment.BASE_API_URL+this.infoDatasource.api+"/DeleteAllCer?IdAlboCarrozzeriaMobile="+this.idTabRif;           
      return this.httpClient.post(EndPoint, body,{headers})
      .toPromise()
      .then(response  =>{        
        let messaggioChiusura: messagefromComponent = {
          codeMessage: 1,
          destComponent: "EditaGgrigliaSer",
          traceMessage: 'refresh',
          detailsMessage:""
        }
        setTimeout(() => {
          this.userComponentService.emitMessage(messaggioChiusura); 
        }, 200);
        console.log(response)}) 
      .catch();
  
    }
    //console.log(event);
  }
  async decodePaste(cerPaste:string) { 
    let cerPasteArr=[];
    let cerPasteArrResult=[];

    if(!cerPaste.includes(".")){
      alert("errore ne formato  xx.xx.xx - xx.xx.xx");      
      return;
  }

   

    if(!cerPaste.includes("-")){   
        let result=cerPaste.replace(/\*/g, '');     
        cerPasteArr=result.split(".");//cerPaste.split(".");
        let idx=-1;
        let mioCer="";
        cerPasteArr.forEach(element => {
            idx++;
            if(element.length==4){
              let currentCer="";
              if(mioCer=="") {
                currentCer=cerPasteArr[idx-2]+cerPasteArr[idx-1]+element.substring(0,2);
                mioCer=element.substring(2)
                cerPasteArrResult.push(currentCer);
              }else {
                currentCer=mioCer+cerPasteArr[idx-1]+element.substring(0,2);
                mioCer=element.substring(2)
                cerPasteArrResult.push(currentCer);
              }
              
              

            }

        });
        
    }else{
      let result=cerPaste.replace(/\./g, '');
      result=result.replace(/\*/g, '');
      result=result.replace(/\ /g, '');
      cerPasteArrResult=result.split("-");
    }

    let promise=[]
    const value={  
      "id": 0,
      "idAlboCarrozzeriaMobile": this.idTabRif,
      "cer": "",
      "AllCER":cerPasteArrResult  
    }
    const EndPoint=environment.BASE_API_URL+this.infoDatasource.api;// "AlboCarrozzeriaMobileCer";
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'text');      
    const body=value;

    return this.httpClient.post(EndPoint, body,{headers})
    .toPromise()
    .then(response  =>{
      console.log(response)}) 
    .catch();
}

  async paste() {       
    navigator.clipboard.readText().then(cerPaste=>{
     this.spinner.show();
     this.decodePaste(cerPaste).then(value=>{        
       
       let messaggioChiusura: messagefromComponent = {
         codeMessage: 1,
         destComponent: "EditaGgrigliaSer",
         traceMessage: 'refresh',
         detailsMessage:""
       }
       setTimeout(() => {
         this.userComponentService.emitMessage(messaggioChiusura); 
         this.spinner.hide();
       }, 2000);
     

       //alert("Forse ho Finito");
     });
   
   });
 }
 
}
